import { Avatar } from '@mui/material';
import ButtonBase from '@mui/material/ButtonBase';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import MenuChannelOptions from '../../../components/Contact/Conversation/MenuChannelOptions/MenuChannelOptions';
import { ContactDisplayLayout } from '../../../sic-lib/enums/ContactDisplayLayout';
import { Contact } from '../../../sic-lib/types/Contact';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        height: 'inherit',
        paddingTop: theme.spacing(1),
        paddingBottom: theme.spacing(1),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    text: {
        [theme.breakpoints.down('lg')]: {
            maxWidth: '248px',
        },
    },
    flexChild: {
        height: 'inherit',
    },
    list: {
        display: 'flex',
        height: 'inherit',
        '& .MuiListItemIcon-root': {
            justifyContent: 'center',
        },
    },
}));

interface Props {
    contact: Contact;
    hasMediumScreen: boolean;
    cdDispatch: React.Dispatch<{ view: ContactDisplayLayout }>;
}

export default function MainHeader({ contact, hasMediumScreen, cdDispatch }: Props) {
    const { classes } = useStyles();

    const handleShowDetails = () => {
        if (!hasMediumScreen) {
            cdDispatch({ view: ContactDisplayLayout.aside });
        }
    };

    const salutation = React.useMemo(() => {
        return contact.values.find(itm => itm.fieldId === 15)?.value || '';
    }, [contact]);

    return (
        <Grid
            container
            direction="row"
            wrap="nowrap"
            alignItems="center"
            className={classes.root}
            spacing={1}
        >
            <Grid item xs={true} display="flex" justifyContent="left">
                {!hasMediumScreen && (
                    <ButtonBase aria-label="Toggle contact info" onClick={handleShowDetails}>
                        <Typography component="h2" variant="h6" noWrap className={classes.text}>
                            {contact.firstName} {contact.lastName}
                        </Typography>
                    </ButtonBase>
                )}
                {hasMediumScreen && (
                    <Grid container spacing={2} className="box" alignItems="center">
                        <Grid item>
                            <Avatar variant="rounded">{contact.firstName?.slice(0, 1)}</Avatar>
                        </Grid>
                        <Grid item>
                            <Typography component="h2" variant="h6" noWrap>
                                {contact.firstName} {salutation ? `"${salutation}"` : ''}{' '}
                                {contact.lastName}
                            </Typography>
                        </Grid>
                    </Grid>
                )}
            </Grid>
            <Grid item xs="auto">
                <MenuChannelOptions />
            </Grid>
            {/*<Grid item xs='auto'>
                <PopoverContactCalling
                    contact={contact}
                />
            </Grid>*/}
        </Grid>
    );
}
